import { OnDestroy, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
export var UNKNOWN_OLDER_VERSION = 'undeclared';
var UiMachineRobotVersionsDisplayComponent = /** @class */ (function () {
    function UiMachineRobotVersionsDisplayComponent(_translateService, appState) {
        var _this = this;
        this._translateService = _translateService;
        this.versionsSummary$ = new BehaviorSubject('');
        this.value$ = new BehaviorSubject('');
        this._destroyed$ = new Subject();
        this._update = function () {
            var value = _this._computeValue();
            _this.value$.next(value);
            _this.versionsSummary$.next(_this._isSingleVersion ? value : _this._getVersionsSummary());
        };
        appState.language.change$
            .pipe(takeUntil(this._destroyed$))
            .subscribe(this._update);
    }
    Object.defineProperty(UiMachineRobotVersionsDisplayComponent.prototype, "robotVersions", {
        get: function () {
            return this._robotVersions;
        },
        set: function (robotVersions) {
            this._robotVersions = robotVersions;
            if (robotVersions.length === 1) {
                var robotVersion = robotVersions[0];
                this._isSingleVersion = robotVersion.count == null ||
                    robotVersion.count === 1;
            }
            this.knownVersions = this._getKnownVersions(this._robotVersions);
            this.hasUnknownVersions = this._hasUnknownVersions(this._robotVersions);
            this._update();
        },
        enumerable: true,
        configurable: true
    });
    UiMachineRobotVersionsDisplayComponent.prototype.ngOnDestroy = function () {
        this.value$.complete();
        this.versionsSummary$.complete();
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    UiMachineRobotVersionsDisplayComponent.prototype._getVersionsSummary = function () {
        var _this = this;
        var oldVersionText = this._translateService.instant('robot_versions_grid_version_undeclared');
        var unknownVersionText = this._translateService.instant('robot_versions_grid_version_unknown');
        var mappedVersions = this.robotVersions
            .map(function (robotVersion) {
            var version = robotVersion.version === UNKNOWN_OLDER_VERSION ?
                oldVersionText :
                robotVersion.version || unknownVersionText;
            var robotsCount = robotVersion.count;
            return _this._translateService.instant('robot_versions_grid_version_tooltip_row_summary', {
                version: version,
                robotsCount: robotsCount,
            });
        })
            .sort();
        if (mappedVersions.length > 0) {
            // add Total row
            if (mappedVersions.length > 1) {
                var robotsCount = this.robotVersions.reduce(function (acc, curr) { return acc += curr.count; }, 0);
                mappedVersions.push(this._translateService.instant('robot_versions_grid_version_tooltip_total_summary', {
                    robotsCount: robotsCount,
                }));
            }
            return mappedVersions.join('\n');
        }
        return this._translateService.instant('robot_versions_grid_version_no_robots');
    };
    UiMachineRobotVersionsDisplayComponent.prototype._getKnownVersions = function (robotVersions) {
        return robotVersions
            .reduce(function (acc, curr) { return acc + (curr.version ? 1 : 0); }, 0);
    };
    UiMachineRobotVersionsDisplayComponent.prototype._hasUnknownVersions = function (robotVersions) {
        return robotVersions
            .filter(function (item) { return !item.version; })
            .length > 0;
    };
    UiMachineRobotVersionsDisplayComponent.prototype._computeValue = function () {
        if (this.robotVersions.length <= 1) {
            var robotVersion = this.robotVersions[0];
            if (robotVersion) {
                if (robotVersion.version === UNKNOWN_OLDER_VERSION) {
                    return this._translateService.instant('robot_versions_grid_version_undeclared');
                }
                return robotVersion.version ||
                    this._translateService.instant('robot_versions_grid_version_unknown');
            }
            return this._translateService.instant('robot_versions_grid_version_no_robots');
        }
        return this._translateService.instant('robot_versions_grid_version_count', {
            knownVersions: this.knownVersions + (this.hasUnknownVersions ? '+' : ''),
        });
    };
    return UiMachineRobotVersionsDisplayComponent;
}());
export { UiMachineRobotVersionsDisplayComponent };
